import { api } from '../../ui/app/api';
import { closePanel, ui } from '../../ui/app/store';
import { Window } from '../../ui/app/Window';
import type { Game } from '../../game/Game';
import { PETS, setPet } from '.';

export function PetsPanel() {
  void ui.version.value;
  const game = api() as unknown as Game;
  const prog = game.progression;
  const level = prog?.char.level ?? 1;
  const current = prog?.char.flags.pet;
  return (
    <Window title="Companions" width={480} onClose={closePanel}>
      <p class="muted" style={{ marginTop: 0 }}>
        Companions follow you everywhere and other adventurers can see them.
      </p>
      {PETS.map((p) => {
        const open = level >= p.level;
        const active = current === p.id;
        return (
          <div key={p.id} class="kv" style={{ alignItems: 'center', gap: '12px', padding: '8px 2px' }}>
            <div>
              <b style={{ color: open ? 'var(--gold-100)' : 'var(--text-3)' }}>{p.name}</b>
              <div class="muted" style={{ fontSize: '12px' }}>{open ? p.description : `Unlocks at level ${p.level}.`}</div>
            </div>
            <button
              class={`btn${active ? '' : ' btn--gold'}`}
              disabled={!open}
              onClick={() => {
                setPet(game, active ? null : p.id);
                ui.version.value++;
              }}
            >
              {active ? 'Dismiss' : 'Summon'}
            </button>
          </div>
        );
      })}
    </Window>
  );
}
